import exLanguage from '../../../language';
import * as exSelect from '../../../forms/select';
import * as exElement from '../../../utils/element';
import * as exIcon from '../../../utils/icon';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function addOption(ctx: Context): any {
    ctx.shared.elements.addOption = {};

    function init(): void {
        // If not using is add option
        if (ctx.shared.config.isAddOption !== true) {
            return;
        }

        //
        create();
        events();
    }

    function create(): void {
        // Get element (search input)
        const elSearchInput = ctx.search.getInputElement();

        // If using search
        if (ctx.shared.config.isSearch === true) {
            elSearchInput.setAttribute('placeholder', exLanguage.line('select.search_here_or_add_option_here'));
        }
        // Is default
        else {
            elSearchInput.setAttribute('placeholder', exLanguage.line('select.add_option_here'));
        }

        // --------------------------------------------------------------------

        // Create element (icon)
        const elIcon = exIcon.create({
            class: {
                new: 'search-icon',
                add: 'fa-solid fa-plus',
            },
            attr: {
                title: exLanguage.line('select.add_option'),
            },
        });
        ctx.shared.elements.search.text.appendChild(elIcon);
        ctx.shared.elements.addOption.icon = elIcon;
    }

    function events(): void {
        // Create event (click)
        ctx.shared.elements.addOption.icon.addEventListener('click', function (this): any {
            ctx.text.getElement().hideDropdown();

            // ----------------------------------------------------------------

            // Get value (search input)
            const value = ctx.search.getInputValue();

            // Add Options
            exSelect.addOptions(ctx.current.getElement(), {
                data: {
                    [value]: value,
                },
            });

            // ----------------------------------------------------------------

            // If using function add option
            if (typeof ctx.shared.config.fnAddOption === 'function') {
                ctx.shared.config.fnAddOption.call(this, {
                    [value]: value,
                });
            }

            // ----------------------------------------------------------------

            //
            ctx.helpers.reset();

            // Set current selected
            ctx.current.setValue(value);

            //
            ctx.read.reset();
        });
    }

    // ------------------------------------------------------------------------

    function progress(): void {
        // If not using add option
        if (ctx.shared.config.isAddOption !== true) {
            return;
        }

        // --------------------------------------------------------------------

        // Get element (search input)
        const elSearchInput = ctx.search.getInputElement();

        // Get list search result
        const listSearchResult = ctx.search.getResultValue();

        //
        const find = listSearchResult.find(function (item): any {
            if (item.value === elSearchInput.value) {
                return true;
            }
        });

        //
        if (find) {
            hideElement();
        }
        //
        else {
            //
            if (elSearchInput.value) {
                showElement();
            }
            //
            else {
                hideElement();
            }
        }
    }

    // ------------------------------------------------------------------------

    function clear(): void {
        // If not using add option
        if (ctx.shared.config.isAddOption !== true) {
            return;
        }

        // --------------------------------------------------------------------

        // Clear search input
        ctx.search.clearValue();

        // Hide element (option icon)
        hideElement();
    }

    // ------------------------------------------------------------------------

    function getElement(): HTMLElement {
        return ctx.shared.elements.addOption.icon;
    }

    function showElement(): void {
        exElement.show(getElement(), 'inline');
    }

    function hideElement(): void {
        exElement.hide(getElement());
    }

    // ------------------------------------------------------------------------

    return {
        init,
        progress,
        clear,
        getElement,
        showElement,
        hideElement,
    };
}

// ----------------------------------------------------------------------------

export default addOption;
